export default __webpack_public_path__ + "static/JourneysofPaul-79d7fd05ff6b590cbd7873975ad56961.jpg";